import React, { useState, useRef } from 'react'
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  IconButton,
  Button,
} from '@material-ui/core'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import moment from 'moment'
import { makeStyles } from '@material-ui/core'
import ButtonCircularProgress from 'src/component/ButtonCircularProgress'
import { ImArrowRight2 } from 'react-icons/im'
import { useHistory, Link } from 'react-router-dom'
import DescriptionIcon from '@material-ui/icons/Description'
import NoDataFound from 'src/DataNotFound'
import axios from 'axios'
import apiConfig from 'src/APIconfig/ApiConfig'
import { toast } from 'react-toastify'
import ChildTable from './ChildTable'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
const useStyles = makeStyles((theme) => ({
  mainbox: {
    background: theme.palette.background.dark1,
    paddingTop: '0px',
    paddingBottom: '100px',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '50px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0px',
    },

    '& h1': {
      fontSize: '50px',
      fontWeight: '600',
      color: theme.palette.text.black,
      marginBottom: '20px',
      paddingTop: '40px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '30px',
      },
      [theme.breakpoints.down('xs')]: {
        paddingTop: '0px',
      },
    },
  },
  box: {
    '& p': {
      fontSize: '10px',
      fontWeight: '400',
      background: 'hsl(203deg 95% 93%)',
      display: 'inline-block',
      padding: '1px 5px',
    },
  },
  scorebox: {
    backgroundColor: '#d8ffeb',
    padding: '4px',
    maxWidth: '50px',
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tableCell: {
    borderRight: ' .1px solid rgba(224, 224, 224, 1)',
  },
  searchBar: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    border: '2px solid rgba(224, 224, 224, 1)',
    width: '100%',
    height: '30px',
    '& input': {
      border: 'none',
      outline: 'none',
      width: '100%',
      height: '100%',
    },
  },
  icon: {
    width: '1.23em',
    height: '1.23em',
    border: '.1px solid rgba(224, 224, 224, 1)',
    color: 'rgba(224, 224, 224, 1)',
  },
  // borderBox: {
  //   position: 'relative',
  //   '&::after': {
  //     position: ' absolute',
  //     bottom: '-32px',
  //     // width: '100%',
  //     height: '0px',
  //     content: "''",
  //     border: '1px solid #ccc',
  //     borderStyle: 'dashed',
  //   },
  // },
  container: {
    '& .TableHeadrow': {
      '& th': {
        border: 'none',
        color: theme.palette.text.black,
      },
    },
  },
  fullList: {
    marginTop: '16px',
    position: 'relative',
    zIndex: '1',
    '& a': {
      padding: '10px',
      height: '30px',
      '& svg': {
        marginLeft: '10px',
      },
    },
  },
  texthead1: {
    color: theme.palette.text.black,
  },
}))

export default function Race(props) {
  const classes = useStyles()
  const history = useHistory()
  const {
    data,
    isLoadingData,
    latestSearchData,
    web3,
    auth,
    filterTable,
    setFilterTable,
  } = props

  return (
    <Box className={classes.mainbox}>
      <Box mb={2} display="flex" alignItems="center">
        <Typography variant="h1">Last Scan</Typography>
        <Box style={{ marginTop: '20px', marginLeft: '10px' }}>
          {isLoadingData && <ButtonCircularProgress />}
        </Box>
      </Box>
      <Box className={classes.borderBox}>
        <TableContainer className={classes.container}>
          <Table aria-label="sticky table">
            <TableHead className="TableHead">
              <TableRow className="TableHeadrow">
                <TableCell>TOKEN </TableCell>
                <TableCell
                  onClick={() =>
                    setFilterTable({
                      score: !filterTable?.score,
                      interest: false,
                      marketcap: false,
                      price: false,
                      age: false,
                    })
                  }
                  style={{ cursor: 'pointer' }}
                >
                  <Box display="flex" alignItems="center">
                    <span>SCORE</span>

                    {!filterTable?.score ? (
                      <ArrowDropDownIcon />
                    ) : (
                      <ArrowDropUpIcon />
                    )}
                  </Box>
                </TableCell>
                <TableCell
                  onClick={() =>
                    setFilterTable({
                      interest: !filterTable?.interest,
                      score: false,
                      marketcap: false,
                      price: false,
                      age: false,
                    })
                  }
                  style={{ cursor: 'pointer' }}
                >
                  <Box display="flex" alignItems="center">
                    <span>INTEREST</span>
                    {!filterTable?.interest ? (
                      <ArrowDropDownIcon />
                    ) : (
                      <ArrowDropUpIcon />
                    )}
                  </Box>
                </TableCell>
                <TableCell>NETWORK</TableCell>
                <TableCell
                  onClick={() =>
                    setFilterTable({
                      price: !filterTable?.price,
                      interest: false,
                      score: false,
                      marketcap: false,
                      age: false,
                    })
                  }
                  style={{ cursor: 'pointer' }}
                >
                  <Box display="flex" alignItems="center">
                    <span>PRICE</span>
                    {!filterTable?.price ? (
                      <ArrowDropDownIcon />
                    ) : (
                      <ArrowDropUpIcon />
                    )}
                  </Box>
                </TableCell>

                <TableCell
                  onClick={() =>
                    setFilterTable({
                      marketcap: !filterTable?.marketcap,
                      price: false,
                      interest: false,
                      score: false,
                      age: false,
                    })
                  }
                  style={{ cursor: 'pointer' }}
                >
                  <Box display="flex" alignItems="center">
                    <span> MARKET CAP</span>
                    {!filterTable?.marketcap ? (
                      <ArrowDropDownIcon />
                    ) : (
                      <ArrowDropUpIcon />
                    )}
                  </Box>
                </TableCell>
                <TableCell
                  onClick={() =>
                    setFilterTable({
                      age: !filterTable?.age,
                      marketcap: false,
                      price: false,
                      interest: false,
                      score: false,
                    })
                  }
                  style={{ cursor: 'pointer' }}
                >
                  <Box display="flex" alignItems="center">
                    <span> AGE</span>
                    {!filterTable?.age ? (
                      <ArrowDropDownIcon />
                    ) : (
                      <ArrowDropUpIcon />
                    )}
                  </Box>
                </TableCell>
                <TableCell>SHARE COUNT</TableCell>
                <TableCell>REPORT</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.TableBody}>
              {latestSearchData &&
                latestSearchData
                  ?.slice(0, 10)
                  ?.map((data, i) => (
                    <ChildTable data={data} index={i} web3={web3} auth={auth} />
                  ))}
              {!isLoadingData &&
                latestSearchData &&
                latestSearchData.length === 0 && <NoDataFound />}

              {/* {isLoadingData && (
                <TableRow
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <ButtonCircularProgress />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box align="right" className={classes.fullList}>
        {latestSearchData && latestSearchData.length > 5 && (
          <Button
            variant="contained"
            size="small"
            color="primary"
            to="/view-token"
            component={Link}
          >
            See Full List <ImArrowRight2 />
          </Button>
        )}

        {/* <Link to="/full-list">
          See Full List <ImArrowRight2 />
        </Link> */}
      </Box>
    </Box>
  )
}
